import React, {Component} from 'react'
import {hot} from 'react-hot-loader'
import {Route, Switch, Redirect} from 'react-router-dom'
import {Query} from 'react-apollo'
import styled from '@emotion/styled'
import universal from 'react-universal-component'

import './fonts.css'
import './normalize.css'
import './main.css'

import Error from '../../base/Error'
import Loading from '../../base/Loading'
import currentUserGql from './current-user.graphql'

const UniversalCatalog = universal(import('../../catalog/Root'), {ignoreBabelRename: true})

const Container = styled.div`
`

class AppLayout extends Component {
  render() {
    return <Container>
      <Switch>
        <Route path="/app/catalog" render={props => <UniversalCatalog {...props} currentUser={this.props.currentUser}/>}/>
        <Redirect to="/app/catalog/client"/>
      </Switch>
    </Container>
  }
}

const App = () => <Query query={currentUserGql}>
  {({ loading, error, data }) => {
    if (loading) return <Loading/>
    if (error) return <Error/>

    return <AppLayout currentUser={data.currentUser}/>
  }}
</Query>


export default hot(module)(App)
